import { lazy } from 'react';

const countUserPageConfiguration = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/configuration/count/user',
			component: lazy(() => import('./CountUserContainer'))
		}
	]
};

export default countUserPageConfiguration;
